import ProductTypesEnum from '@/models/ProductTypesEnum';

export default {
    data() {
        return {
            isExpired: false
        };
    },
    props: {
        productDetails: {
            type: Object,
            required: true
        },
        product: {
            type: Object,
            required: true
        },
        teaser: {
            type: Object,
            default() {
                return {};
            }
        },
        hotelDetails: {
            type: Object,
            default() {
                return {};
            }
        },
        isOtherProduct: Boolean,
        extraServicesAndInfos: {
            type: Array,
            default() {
                return [];
            }
        },
        marker: Object,
        relatedProducts: Object,
        hotelProducts: Object
    },
    computed: {
        showHotelPrimary() {
            return this.hotelDetails.hotelClassification || this.hotelDetails.name;
        },
        showFeatures() {
            return (
                !this.productDetails.webshopAccessCodeProduct && !this.isOtherProduct && this.productDetails.hotelTags
            );
        },
        showServices() {
            return this.$getSafe(this.productDetails, 'services.length');
        },
        showVoucherInfos() {
            return this.productDetails.voucherInfos;
        },
        showMap() {
            return this.$getSafe(this.productDetails, 'latLon.length') && !this.isOtherProduct;
        },
        showHotelDescription() {
            return this.productDetails.hotelDescription && !this.isOtherProduct;
        },
        showFacilities() {
            return (
                !this.productDetails.webshopAccessCodeProduct &&
                (this.extraServicesAndInfos.length || this.$getSafe(this.productDetails, 'facilityTags.length')) &&
                !this.isOtherProduct
            );
        },
        showImageGallery() {
            return this.$getSafe(this.productDetails, 'images.length') > 1;
        },
        hasHotelProducts() {
            return !!(this.product.otherProductsOfHotel || []).length;
        },
        mapSectionHeader() {
            return !this.isOtherProduct ? this.$t('ProductDetails.tab.map') : this.$t('HotelAddress.term.provider');
        },
        descriptionSectionHeader() {
            return this.showHotelDescription
                ? this.$t('ProductDetails.tab.hotel')
                : this.$t('VoucherDetails.tab.description');
        },
        hotelDescriptionSectionHeader() {
            return !this.productDetails.webshopAccessCodeProduct
                ? this.$t('ProductDetails.section.aboutHotelAndRegion')
                : this.$t('ProductDetails.section.furtherVoucherInformation');
        },
        voucherInfosSectionHeader() {
            return !this.isOtherProduct
                ? this.showHotelPrimary
                    ? this.$t('ProductDetails.section.voucherInfos')
                    : this.$t('VoucherDetails.section.voucherInfos')
                : this.$t('ProductDetails.section.additionalInfo');
        },
        servicesSectionHeader() {
            return this.productDetails.hotelTags
                ? this.$t('ProductDetails.section.lookForwardTo')
                : this.$t('VoucherDetails.section.services');
        },
        ratingInfo() {
            return this.productDetails.ratingInfo;
        },
        isValueVoucher() {
            return [ProductTypesEnum.VALUE_VOUCHER, ProductTypesEnum.MULTI_VOUCHER].includes(
                this.productDetails.productCategory
            );
        }
    }
};
